module.exports = __webpack_public_path__ + "img/logo.d59ab8e5.png";